document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".menu-drawer__inner-container").forEach((container) => {
    if (container.dataset.tabsInit === "1") return;
    container.dataset.tabsInit = "1";

    const header = container.querySelector(".menu-drawer__header");
    const nav = container.querySelector("nav.menu-drawer__navigation[data-mobile-tabs]");
    if (!header || !nav) return;

    const tabs = header.querySelectorAll(".menu-drawer__tab");
    const panes = nav.querySelectorAll(".menu-drawer__pane");
    const scrollContainer = container.querySelector(".menu-drawer__navigation-container");
    if (tabs.length < 2 || panes.length < 2) return;

    /* ── A11y: ARIA Tab-Pattern ── */
    const tablistEl = tabs[0].parentElement;
    if (tablistEl) {
      tablistEl.setAttribute("role", "tablist");
      tablistEl.setAttribute("aria-label", "Navigation");
    }
    tabs.forEach((t, i) => {
      const panelId = `menu-drawer-panel-${i}`;
      const tabId = `menu-drawer-tab-${i}`;
      t.setAttribute("role", "tab");
      t.setAttribute("id", tabId);
      t.setAttribute("aria-controls", panelId);
      t.setAttribute("tabindex", i === 0 ? "0" : "-1");
    });
    panes.forEach((p, i) => {
      p.setAttribute("role", "tabpanel");
      p.setAttribute("id", `menu-drawer-panel-${i}`);
      p.setAttribute("aria-labelledby", `menu-drawer-tab-${i}`);
    });

    let activeTab = 0;
    const scrollPositions = {};
    let savedOpenAccordions = []; // IDs der offenen Accordions speichern

    const setActive = (idx) => {
      // Scroll-Position des aktuellen Tabs speichern
      if (scrollContainer) scrollPositions[activeTab] = scrollContainer.scrollTop;
      activeTab = idx;

      tabs.forEach((t, i) => {
        t.classList.toggle("is-active", i === idx);
        t.setAttribute("aria-selected", i === idx ? "true" : "false");
        t.setAttribute("tabindex", i === idx ? "0" : "-1");
      });
      panes.forEach((p, i) => p.classList.toggle("is-active", i === idx));

      // Accordions NICHT schließen – State bleibt pro Tab erhalten

      // Scroll-Position des neuen Tabs wiederherstellen
      if (scrollContainer) scrollContainer.scrollTop = scrollPositions[idx] || 0;
    };

    // State speichern/wiederherstellen wenn Dawn den Drawer schließt/öffnet
    const mainDetails = container.closest("details.menu-drawer-container");
    if (mainDetails) {
      // Dawn entfernt beim Schließen alle inner details[open] – State vorher sichern
      const saveState = () => {
        savedOpenAccordions = [];
        nav.querySelectorAll("details.menu-drawer__accordion[open]").forEach((d) => {
          if (d.id) savedOpenAccordions.push(d.id);
        });
      };

      const restoreState = () => {
        // Aktiven Tab wiederherstellen
        setActive(activeTab);
        // Offene Accordions wiederherstellen
        savedOpenAccordions.forEach((id) => {
          const d = document.getElementById(id);
          if (d) d.setAttribute("open", "");
        });
      };

      // MutationObserver auf das Haupt-<details> Element
      new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.attributeName === "open") {
            if (mainDetails.hasAttribute("open")) {
              // Drawer wird geöffnet – State wiederherstellen (nach Dawn's Init)
              requestAnimationFrame(() => restoreState());
            } else {
              // Drawer wird geschlossen – State VOR Dawn's Cleanup sichern
              // (wird durch den click-handler getriggert, bevor closeMenuDrawer läuft)
            }
          }
        }
      }).observe(mainDetails, { attributes: true, attributeFilter: ["open"] });

      // State sichern bei jedem Summary-Klick BEVOR Dawn aufräumt
      const mainSummary = mainDetails.querySelector(":scope > summary");
      if (mainSummary) {
        mainSummary.addEventListener("click", () => {
          if (mainDetails.hasAttribute("open")) {
            // Drawer ist gerade offen → wird geschlossen → State sichern
            saveState();
          }
        }, true); // capture phase = vor Dawn's Handler
      }

      // Auch beim Close-Button State sichern
      container.addEventListener("click", (e) => {
        if (e.target.closest(".menu-drawer__close-btn")) {
          saveState();
        }
      }, true);
    }

    // CAPTURE + stopPropagation => Drawer bleibt offen
    tabs.forEach((tab) => {
      tab.addEventListener("pointerdown", (e) => {
        e.preventDefault();
        e.stopPropagation();
      }, true);

      tab.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        setActive(Number(tab.dataset.tab));
      }, true);
    });

    /* ── A11y: Arrow-Key Navigation zwischen Tabs ── */
    if (tablistEl) {
      tablistEl.addEventListener("keydown", (e) => {
        const idx = Array.from(tabs).indexOf(e.target);
        if (idx === -1) return;
        let next = -1;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") next = (idx + 1) % tabs.length;
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") next = (idx - 1 + tabs.length) % tabs.length;
        if (e.key === "Home") next = 0;
        if (e.key === "End") next = tabs.length - 1;
        if (next !== -1) {
          e.preventDefault();
          setActive(next);
          tabs[next].focus();
        }
      });
    }
  });
});

/* ── Drawer: Close search when menu opens ── */
(function () {
  var details = document.getElementById('Details-menu-drawer-container');
  if (!details) return;
  details.addEventListener('toggle', function () {
    if (details.open) {
      var search = document.querySelector('revolor-search');
      if (search && search.isOpen && typeof search.close === 'function') search.close();
    }
  });
})();

/* ── Menu Drawer Close-Button ────────────────────────────── */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.menu-drawer__close-btn');
  if (!btn) return;
  var drawer = btn.closest('header-drawer');
  if (drawer) {
    var summary = drawer.querySelector('summary');
    if (summary) summary.click();
  }
});

/* ── Drawer-Inline-Search: Live-Suche im Burger-Menü ────── */
(function () {
  var details = document.getElementById('Details-menu-drawer-container');
  if (!details) return;

  var searchBound = false;
  var searchTimer = null;
  var searchAbort = null;
  var cache = {};
  var defaultsLoaded = false;

  function enterSearchMode(results) {
    var tpl = document.querySelector('[data-search-default-products]');
    var tabs = details.querySelector('.menu-drawer__tabs');
    var closeBtn = details.querySelector('[data-drawer-search-back]');
    if (tpl && tpl.innerHTML.trim()) {
      results.innerHTML = '<div class="revolor-search__defaults" style="padding:2rem;">'
        + '<div class="rps__products">' + tpl.innerHTML + '</div></div>';
      results.hidden = false;
    }
    if (tabs) tabs.style.display = 'none';
    if (closeBtn) closeBtn.hidden = false;
  }

  function exitSearchMode(results) {
    var tabs = details.querySelector('.menu-drawer__tabs');
    var closeBtn = details.querySelector('[data-drawer-search-back]');
    var input = details.querySelector('[data-drawer-search-input]');
    results.hidden = true;
    results.innerHTML = '';
    if (tabs) tabs.style.display = '';
    if (closeBtn) closeBtn.hidden = true;
    if (input) { input.value = ''; input.blur(); }
  }

  function doSearch(input, results, clearBtn) {
    var term = input.value.trim();

    if (clearBtn) clearBtn.hidden = term.length === 0;

    if (term.length < 2) {
      if (term.length === 0) {
        enterSearchMode(results);
      }
      return;
    }

    results.hidden = false;

    var key = term.toLowerCase().replace(/\s+/g, '-');
    if (cache[key]) {
      results.innerHTML = cache[key];
      return;
    }

    if (searchAbort) searchAbort.abort();
    searchAbort = new AbortController();

    results.innerHTML = '<div style="padding:3rem;text-align:center;color:#999;">Suche…</div>';

    fetch(
      window.routes.predictive_search_url +
      '?q=' + encodeURIComponent(term) +
      '&section_id=revolor-predictive-search' +
      '&resources[type]=product&resources[limit]=6',
      { signal: searchAbort.signal }
    )
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var section = doc.querySelector('#shopify-section-revolor-predictive-search');
        if (!section) return;
        cache[key] = section.innerHTML;
        results.innerHTML = section.innerHTML;
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        results.innerHTML = '';
      });
  }

  details.addEventListener('toggle', function () {
    if (details.open && !searchBound) {
      var input = details.querySelector('[data-drawer-search-input]');
      var results = details.querySelector('[data-drawer-search-results]');
      if (!input || !results) return;

      searchBound = true;

      input.addEventListener('focus', function () {
        if (!input.value.trim()) enterSearchMode(results);
      });

      var closeBtn = details.querySelector('[data-drawer-search-back]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          exitSearchMode(results);
        });
      }

      function onInput() {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          doSearch(input, results, closeBtn);
        }, 300);
      }
      input.addEventListener('input', onInput);
      input.addEventListener('keyup', onInput);
    }

    if (!details.open) {
      var results = details.querySelector('[data-drawer-search-results]');
      if (results) exitSearchMode(results);
    }
  });
})();

/* ── Accordion-Submenus: Dawn's Slide-Over verhindern ───── */
document.addEventListener('click', function (e) {
  var summary = e.target.closest('.menu-drawer__accordion > summary');
  if (!summary) return;

  // Kurz warten bis Dawn seine Klassen gesetzt hat, dann aufräumen
  setTimeout(function () {
    var details = summary.parentElement;
    if (!details) return;

    // submenu-open entfernen (Dawn versteckt sonst das Hauptmenü)
    var parent = details.closest('.submenu-open');
    if (parent) parent.classList.remove('submenu-open');

    // menu-opening nicht nötig für Inline-Accordion
    details.classList.remove('menu-opening');

    // Focus-Trap entfernen (Dawn setzt trapFocus auf Submenu)
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
  }, 150);
}, true);

/* ── Mega Menu: L2 hover → L3 panel ──────────────────────── */
document.querySelectorAll('.mega-menu__list').forEach(function (menu) {
  var items = menu.querySelectorAll('.mega-menu__l2-item[data-mega-target]');
  var panels = menu.querySelectorAll('.mega-menu__l3-panel[data-mega-panel]');
  if (!items.length || !panels.length) return;

  items.forEach(function (item) {
    var link = item.querySelector('.mega-menu__link');
    if (!link) return;
    link.addEventListener('mouseenter', function () {
      var target = item.dataset.megaTarget;
      items.forEach(function (i) { i.classList.remove('is-active'); });
      item.classList.add('is-active');
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      var panel = menu.querySelector('[data-mega-panel="' + target + '"]');
      if (panel) panel.classList.add('is-active');
    });
  });

  // Reset auf erstes Item beim Schließen
  var details = menu.closest('details.mega-menu');
  if (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) {
        items.forEach(function (i, idx) { i.classList.toggle('is-active', idx === 0); });
        panels.forEach(function (p, idx) { p.classList.toggle('is-active', idx === 0); });
      }
    });
  }
});